import classNames from 'classnames';
import CheckCircleIcon from '@/shared/icons/flip-ui-kit/large/CheckCircle';
import InformationIcon from '@/shared/icons/flip-ui-kit/large/Information';
import WarningTriangleIcon from '@/shared/icons/flip-ui-kit/large/WarningTriangle';
import CloseIcon from '@/shared/icons/flip-ui-kit/small/Close';

type MessageVariant = 'warning' | 'info' | 'success';

export default function Message({
  message,
  variant,
  onClose,
}: {
  message: React.JSX.Element;
  variant: MessageVariant;
  onClose: () => void;
}) {
  return (
    <div
      className={classNames(
        'flex w-full items-center justify-center bg-opacity-20 p-[5px] font-aeonikMedium text-14',
        // eslint-disable-next-line no-nested-ternary
        variant === 'warning'
          ? 'bg-cf-orange-1 text-cf-orange-1'
          : variant === 'info'
            ? 'bg-cf-blue-1 text-cf-blue-2'
            : 'bg-cf-green-1 text-cf-green-1',
      )}
    >
      <div className="flex items-center gap-x-1 px-8">
        {/* eslint-disable-next-line no-nested-ternary */}
        {variant === 'warning' ? (
          <WarningTriangleIcon />
        ) : variant === 'info' ? (
          <InformationIcon />
        ) : (
          <CheckCircleIcon />
        )}
        <span className="text-center">{message}</span>
      </div>
      <button type="button" onClick={onClose} className="absolute right-4">
        <CloseIcon />
      </button>
    </div>
  );
}
